import EditMealTimesModal from './EditMealTimesModal';

export default EditMealTimesModal;
